import { MRT_Row } from '@talentmesh/table';
import { Button } from '@talentmesh/ui/components/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@talentmesh/ui/components/dropdown-menu';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import useTeamMemberManagementMenuItems from '../Hooks/useTeamMemberManagementMenuItems';
import { MembershipStatus, TeamMember } from '@/Models/TeamMember';
import UIStrings from '@/Utils/UIStrings';

interface MemberManagementButtonProps {
    row: MRT_Row<TeamMember>;
}

function getLabel(status: MembershipStatus): string {
    switch (status) {
        case 'Member':
            return UIStrings.ManageMember;
        case 'Expired':
        case 'Invited':
            return UIStrings.ManageInvitation;
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}

function MemberManagementButton({ row }: MemberManagementButtonProps) {
    const member = row.original;
    const [isOpen, setIsOpen] = useState(false);
    const { status, id } = member;
    const items = useTeamMemberManagementMenuItems(status, id);

    return (
        <DropdownMenu onOpenChange={(x) => setIsOpen(x)}>
            <DropdownMenuTrigger asChild>
                <Button type="button" variant="default-outline-transparent" size="sm">
                    {getLabel(status)} {isOpen ? <ChevronUp /> : <ChevronDown />}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {items.map((item) => (
                    <DropdownMenuItem key={item.label} onClick={item.onClick}>
                        {item.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default MemberManagementButton;
